var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReviews(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: 24,
    height: 24,
    fill: "#2255a1",
    viewBox: "0 0 432 432",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M134 303c3-2 7-1 9 1 2 3 1 7-2 9l-52 40c-3 2-7 1-9-2-1-1-1-2-1-3v-73H33c-5 0-9-1-13-2-4-2-7-4-10-7s-6-7-7-11H2c-1-4-2-8-2-12V33c0-5 1-9 3-13 1-4 4-7 7-10s6-6 10-7c4-2 8-3 13-3h288c5 0 9 1 13 3 4 1 7 4 10 7s6 6 7 10c2 4 3 8 3 13v78c0 3-3 6-6 6-4 0-7-3-7-6V33c0-3 0-6-1-8s-3-5-5-6c-1-2-4-4-6-5s-5-1-8-1H33c-3 0-6 0-8 1s-5 3-6 5c-2 1-4 4-5 6s-1 5-1 8v210c0 2 0 5 1 7 1 3 3 5 5 7 1 2 4 3 6 4s5 1 8 1h52c4 0 6 3 6 7v66l43-32zM85 91c-3 0-6-2-6-6 0-3 3-6 6-6h184c3 0 6 3 6 6 0 4-3 6-6 6H85zm0 79c-3 0-6-3-6-6 0-4 3-7 6-7h53c3 0 6 3 6 7 0 3-3 6-6 6H85zm315 158h-46v72c0 4-3 6-6 6-2 0-4 0-5-1l-77-77h-76c-3 0-6-3-6-7V164c0-4 3-7 6-7h210c4 0 6 3 6 7v157c0 4-2 7-6 7zm-52-13h46V170H196v145h73c1 0 3 1 4 2l68 68v-64c0-3 3-6 7-6zm-14-66c4 0 7 3 7 7 0 3-3 6-7 6h-78c-4 0-7-3-7-6 0-4 3-7 7-7h78z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReviews);
export default __webpack_public_path__ + "static/media/Reviews.fc3a964893593bb04a9c560e8fd3cd44.svg";
export { ForwardRef as ReactComponent };